import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';

import {IonicModule} from '@ionic/angular';
import {HomePageComponent} from './home-page.component';
import {RouterModule} from '@angular/router';
import {BaseModule} from '../../modules/base/base.module';
import {DecorationModule} from '../../modules/decoration/decoration.module';
import {PatternsModule} from '../../modules/patterns/patterns.module';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        IonicModule,
        BaseModule,
        DecorationModule,
        PatternsModule,
        RouterModule.forChild([{path: '', component: HomePageComponent}])
    ],
    declarations: [HomePageComponent]
})
export class HomePageModule {
}
